import React, { useContext, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

import ggaResourcesList from "./ggaResourceList.json";
import DialogueBatch from "../Narrative/DialogueBatch";
import UserProgressContext from "../../userProgressContext";
import SoundManager from "../../services/SoundManager";

const GridGuardArsenal = ({ script }) => {
  const { audioMuted, localProgress, totalScore } =
    useContext(UserProgressContext);
  const navigate = useNavigate();
  const location = useLocation();

  let previousLocationPathname = undefined;
  let crossover = false;
  if (location && location.state) {
    const state = location.state;
    if (state.previousLocationPathname)
      previousLocationPathname = state.previousLocationPathname;
    if (state.crossover) crossover = state.crossover;
  }
  useEffect(() => {
    if (totalScore <= 0 || !previousLocationPathname)
      navigate("/page-not-found");
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const handleGoBackBtn = () => {
    SoundManager.playSfx('game-retro-click');
    setTimeout(() => {
      navigate(previousLocationPathname, {
        state: {
          previousLocationPathname: "/gridGuardArsenal",
          crossover: true,
        },
      });
    }, 100);
    // navigate(previousLocationPathname, {
    //   state: {
    //     previousLocationPathname: "/gridGuardArsenal",
    //     crossover: true,
    //   },
    // });
  };

  const handleGGACardClick = (resource) => {
    SoundManager.playSfx('game-retro-click');
    setTimeout(() => {
      navigate("/gridGuardArsenal/" + resource.id, {
        state: {
          previousLocationPathname: previousLocationPathname,
          resourceObj: resource,
          currScript: script && script[localProgress] && script[localProgress],
        },
      });
    }, 200);
  };

  // console.log("inside gga", previousLocationPathname, crossover);
  return (
    <React.Fragment>
      {script && crossover && script[localProgress] && (
        <DialogueBatch key={localProgress} step={script[localProgress.toString()]} />
      )}
      <div className="relative flex flex-col w-full py-12">
        <div className="absolute top-2 left-2">
          <button
            className={`${
              !crossover ? "visible" : "invisible"
            } hover:cursor-pointer hover:bg-indigo-600 transition-all ease-in delay-100 bg-indigo-500 text-white py-2 px-4 min-[1024px]:px-8 rounded-lg text-sm md:text-xl`}
            onClick={handleGoBackBtn}
          >
            Go Back
          </button>
        </div>
        <h1 className="text-3xl md:text-5xl font-bold mb-4 md:mb-6 text-center">
          GridGuard Arsenal
        </h1>
        <div className="grid grid-cols-1 sm:grid-cols-2 min-[1080px]:grid-cols-3 gap-6">
          {ggaResourcesList &&
            ggaResourcesList["resourceList"] &&
            ggaResourcesList["resourceList"].map((resource, index) => (
              <div
                key={index}
                className={`bg-orange-400/70 flex gap-3 text-left border rounded-lg p-2 cursor-pointer hover:scale-105 hover:bg-orange-400/90 transition-all ease-out duration-300`}
                onClick={() => handleGGACardClick(resource)}
              >
                <div className="flex basis-1/2 w-24 min-[1024px]:w-44 justify-center items-center">
                  <img
                    src={require(`../../static/images/arsenalIcons/${resource.iconName}.png`)}
                    alt="iconImage"
                    className="w-full rounded-lg"
                  ></img>
                </div>
                <div className="flex basis-1/2 flex-col gap-2 p-2">
                  <span className="text-lg font-bold underline decoration-dotted">
                    {resource.label}
                  </span>
                  <span className="text-base">
                    Cost: {resource.points} points
                  </span>
                </div>
              </div>
            ))}
        </div>
      </div>
    </React.Fragment>
  );
};

export default GridGuardArsenal;
